import { Box, Text, CopyClipboard, Divider, Button } from '@wix/design-system';
import React, { useMemo } from 'react';
import { ConfirmSmall } from '@wix/wix-ui-icons-common';
export const KeywordsWidget = _ref => {
  let {
    data
  } = _ref;
  const {
    keywords
  } = data;

  // Function to generate a random number within a specified range
  const generateRandomNumber = (min, max) => Math.floor(Math.random() * (max - min + 1)) + min;

  // Memoize the random numbers for each keyword to keep them constant between re-renders
  const keywordData = useMemo(() => {
    return keywords.map(keyword => ({
      keyword,
      volume: generateRandomNumber(50, 1000),
      competition: generateRandomNumber(1, 100)
    }));
  }, []);
  return /*#__PURE__*/React.createElement(Box, {
    border: "1px",
    padding: "SP2",
    borderStyle: "solid",
    borderColor: "D60",
    borderRadius: 6,
    direction: "vertical",
    gap: "9px"
  }, keywordData.map((data, index) => /*#__PURE__*/React.createElement(Box, {
    key: index,
    direction: "vertical",
    gap: "9px"
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "horizontal",
    gap: 9,
    align: "space-between"
  }, /*#__PURE__*/React.createElement(Box, {
    paddingTop: "3px",
    gap: "3px",
    direction: "vertical"
  }, /*#__PURE__*/React.createElement(Text, {
    weight: "bold",
    size: "tiny"
  }, data.keyword), /*#__PURE__*/React.createElement(Box, {
    direction: "vertical"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "tiny",
    weight: "thin",
    light: true,
    secondary: true
  }, `Volume: ${data.volume}`), /*#__PURE__*/React.createElement(Text, {
    size: "tiny",
    weight: "thin",
    light: true,
    secondary: true
  }, `Competition: ${data.competition}`))), /*#__PURE__*/React.createElement(CopyClipboard, {
    value: data.keyword,
    resetTimeout: 1500
  }, _ref2 => {
    let {
      isCopied,
      copyToClipboard
    } = _ref2;
    return /*#__PURE__*/React.createElement(Box, {
      verticalAlign: "top"
    }, /*#__PURE__*/React.createElement(Button, {
      onClick: () => copyToClipboard(),
      size: "tiny"
    }, isCopied ? /*#__PURE__*/React.createElement(ConfirmSmall, null) : 'Copy'));
  })), index !== keywords.length - 1 && /*#__PURE__*/React.createElement(Divider, null))));
};
export const KEYWORD_SUGGESTIONS_WIDGET = 'KEYWORD_SUGGESTIONS_WIDGET';
//# sourceMappingURL=KeywordSuggestions.js.map